<div
  fxLayout='row'
  fxFill
  *ngIf='cService.isPcViewport || cService.isLargePcViewport'
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
>
  <!-- PC -->
  <mat-drawer-container class='drawer-container custom-drawer-bg' autosize>
    <mat-drawer #drawer class='dialog-sidenav' mode='side' [opened]='dfService.selectedDriverPaneOpened'>
      <div
        class='drilldown-header'
        [style.backgroundColor]="'#' + cService.userProfile.HqColour"
        fxLayout='column'
      >
        <span fxFlex></span>
        <div class='drilldown-sidepane-header' [style.width]='headerContainerWidth'>{{ headerTitle }}</div>
      </div>

      <!-- Search auto-complete -->
      <div class='drilldown-driver-search' fxLayout='row'>
        <div class='search-icon-holder'>
          <mat-icon>search</mat-icon>
        </div>

        <div fxFlex>
          <input
            type='text'
            fxFlex
            [title]="'MESSAGESANDWARNINGS.findDriverThenAddToList' | translate"
            [placeholder]="'MESSAGESANDWARNINGS.addMoreDriversToManage' | translate"
            [matAutocomplete]='auto'
            [formControl]='newItemSearchInput'
          />

          <mat-autocomplete #auto='matAutocomplete'>
            <mat-option
              *ngFor='let item of filteredItems'
              (onSelectionChange)='searchResultSelected(item)'
              [value]="item.firstName + ' ' + item.lastName"
            >
              <span>{{ item.firstName + ' ' + item.lastName }}</span>
              <small *ngIf="item.description">({{ item.description }})</small>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>

      <div>
        <div
          class='drag-and-drop-box'
          *ngFor='let item of paneItems'
          (click)='viewSelectedPaneItem(item)'
          fxLayout='row'
          [class.selected-item-bg]='item.active'
          [class.attention-required]='item.data.outstanding'
        >
          <div fxLayout='row' fxFlex>
            <div class='driver-badge'>
              <div class='driver-initial'>{{ item.title | namesToInitial }}</div>
            </div>

            <div
              fxLayout='column'
              fxFlex
              fxLayoutAlign='center'
              class='margin-l-15'
              style='padding-top: 11px'
            >
              <span [style.font-weight]="item.active ? 'bold' : ''">{{ item.title }}</span>
              <div class='vrm-description-text'>
                <small>{{ item.description }}</small>
              </div>
            </div>

            <counter-badge
              [counter]='item.data.outstanding'
              style='margin-top: 9px'
              *ngIf='item.data.outstanding && showCounterBadge'
            >
            </counter-badge>
          </div>
        </div>
      </div>
    </mat-drawer>
  </mat-drawer-container>

  <div class='custom-drawer' (click)='toggleDrawer()'>
    <button mat-mini-fab vrm-raised-button class='drawer-toggle'>
      <mat-icon class='rotate-item' [class.right]='dfService.selectedDriverPaneOpened'>chevron_right</mat-icon>
    </button>
  </div>
</div>

<!-- Mobile: Floating Options -->
<div *ngIf='cService.isMobileViewport' [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <button
    mat-mini-fab
    type='button'
    [matMenuTriggerFor]='dialogSelectMenu'
    vrm-bg-color
    class='floating-option'
    cdkDrag
    [matBadge]='paneItems.length.toString()'
    matBadgePosition='after'
    matBadgeColor='primary'
  >
    <mat-icon aria-label='Dialog Options'>list</mat-icon>
  </button>
  <mat-menu #dialogSelectMenu [overlapTrigger]='false'>
    <button type='button' mat-menu-item *ngFor='let item of paneItems' (click)='viewSelectedPaneItem(item)'>
      <mat-icon style='color: green' *ngIf='item.data.playlistOutstanding == 0'>check_circle</mat-icon>
      <mat-icon style='color: red' *ngIf='item.data.playlistOutstanding > 0'>error</mat-icon>

      <span [style.font-weight]="item.active ? 'bold' : ''">{{ item.title }}</span>
      <span class='vrm-description-text' *ngIf='item.description'
      >&nbsp; ({{ item.description }})
			</span>
    </button>
  </mat-menu>
</div>
